import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiDayCalendar = {
  defaultProps: {
    fixedWeekNumber: 6,
    showDaysOutsideCurrentMonth: true
  },
  styleOverrides: {
    root: ({ theme }) => ({
      "& .MuiPickersSlideTransition-root": {
        minHeight: "260px"
      },
      // Day Calendar Header Styles
      "& .MuiDayCalendar-header": {
        position: "relative",
        // Horizontal line below week day labels
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: 0,
          left: theme.spacing(3),
          right: theme.spacing(3),
          height: "1px",
          backgroundColor: theme.palette.divider
        },
        "& .MuiDayCalendar-weekDayLabel": {
          color: theme.palette.text.secondary,
          fontSize: capitalDesignTokens.foundations.typography.fontSize.h5,
          fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
          width: 40,
          margin: 0
        }
      },
      // Day Styles
      "& .MuiPickersDay-root": {
        fontSize: capitalDesignTokens.foundations.typography.fontSize.h4,
        fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
        color: theme.palette.text.primary,
        "&.MuiPickersDay-today": {
          color: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
          backgroundColor: "inherit"
        },
        "&.MuiPickersDay-dayOutsideMonth": {
          color: theme.palette.text.disabled
        },
        "&.Mui-disabled": {
          color: theme.palette.text.disabled,
          opacity: 0.4
        },
        "&.Mui-selected": {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.main,
          "&:focus, &:hover": {
            backgroundColor: theme.palette.primary.dark
          }
        },
        "&:hover": {
          backgroundColor: theme.palette.action.hover
        },
        "&.Mui-focusVisible, &:focus-visible": {
          backgroundColor: theme.palette.action.hover,
          outlineOffset: 0
        }
      }
    })
  }
};
export {
  MuiDayCalendar
};
//# sourceMappingURL=MuiDayCalendar.js.map
